import { post } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_STOCKIST_AR_SUMMARY_LIST,
  SET_STOCKIST_CONSIGNMENT_BALANCE_CALCULATION_STATUS,
  SET_STOCKIST_DAILY_TRANSACTION_LIST,
  SET_STOCKIST_DAILY_TRANSACTION_PAYMENTS,
  SET_STOCKIST_DATA,
  SET_STOCKIST_DEPOSIT_REFUND_LIST,
  SET_STOCKIST_LIST_SEARCH_DATA,
  SET_STOCKIST_ORDER_RETURN_LIST,
  SET_STOCKIST_REGISTRATION_LIST,
  SET_STOCKIST_SEARCH_PRODUCT,
} from '../../../store/types'
import Helpers from '../../../helpers'

export const getStockistListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistListing, query).then(response => {
      const json = response.data.data
      commit(SET_STOCKIST_REGISTRATION_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}
export const createUpdateStockist = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistCreateUpdate, query).then(response => {
      resolve(response.data)
    })
  })
}
export const getExistingStockist = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadExistingStockist, query).then(response => {
      const json = response.data.stockist_data
      commit(SET_STOCKIST_DATA, {
        data: json,
      })

      resolve(response.data)
    })
  })
}
export const getStockistOrderReturnListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadStockistOrderReturnListing, query).then(response => {
      const json = response.data.data
      commit(SET_STOCKIST_ORDER_RETURN_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const submitConsignmentOrderReturnAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistConsignmentOrderReturn, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getExistingConsignmentOrderReturn = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadExistingConsignmentOrderReturn, query).then(response => {
      resolve(response.data)
    })
  })
}

export const submitConsignmentDepositAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistConsignmentDeposit, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistDepositSettingsAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadStockistDepositSettings, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistDepositRefundListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistDepositReturnListing, query).then(response => {
      const json = response.data.data
      commit(SET_STOCKIST_DEPOSIT_REFUND_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getExistingStockistDepositRefundAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadExistingStockistDepositRefund, query).then(response => {
      resolve(response.data)
    })
  })
}

export const submitConsignmentRefundAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistConsignmentRefund, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistSearchAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistListing, query).then(response => {
      const json = response.data.data
      commit(SET_STOCKIST_LIST_SEARCH_DATA, {
        list: json.map(opt => ({
          label: opt.name,
          value: opt.stockist_number.toString(),
          sublabel: opt.stockist_number.toString(),
          user_id: opt.stockist_user_id,
          stockist_id: opt.id,
          location_type_id: Helpers.getValue(opt, 'stockist_location.location_types_id', null),
        })),
      })

      resolve(response.data)
    })
  })
}

export const getStockistDailyTransactionListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.loadStockistDailyTransactionList, query).then(response => {
      const json = response.data.stockist_data
      commit(SET_STOCKIST_DATA, {
        data: json,
      })
      const payments = response.data.payment_mode
      commit(SET_STOCKIST_DAILY_TRANSACTION_PAYMENTS, {
        list: payments,
      })
      const invoiceList = response.data.stockist_invoice
      commit(SET_STOCKIST_DAILY_TRANSACTION_LIST, {
        list: {
          data: invoiceList,
          total: invoiceList.length,
        },
      })

      resolve(response.data)
    })
  })
}

export const batchReleaseStockistInvoiceAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.batchReleaseStockistInvoice, query).then(response => {
      resolve(response.data)
    })
  })
}

export const downloadConsignmentOrderReturnNoteAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.downloadConsignmentOrderReturnNote, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getReturnProductForStockistAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistReturnProductSearch, query).then(response => {
      const json = response.data
      commit(SET_STOCKIST_SEARCH_PRODUCT, {
        data: json,
      })

      resolve(response.data)
    })
  })
}

export const checkStockistEligibleReturnAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistEligibleReturnCheck, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistARSummaryAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistARSummary, query).then(response => {
      const json = response.data.data
      commit(SET_STOCKIST_AR_SUMMARY_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getStockistPaymentVerificationListAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.stockistPaymentVerificationList, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const updateStockistPaymentVerificationAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.stockistPaymentVerificationUpdate, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getDailyCollectionReport = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.dailyCollectionReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistConsignmentStockReport = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistConsignmentStockReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistConsignmentStockReportByCountry = ({ commit }, query) => {
  // 直接返回请求链，确保接口异常能够继续传递给调用组件处理。
  return new Promise(resolve => {
    post(api.stockistConsignmentStockReportByCountry, query).then(response => {
      resolve(response.data)
    })
  })
}

export const downloadConsignmentDepositRefundNoteAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.consignmentDepositRefundNote, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistConsignmentBalanceAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.stockistConsignmentCalculateBalance, query)
      .then(response => {
        const result = response.data
        commit(SET_STOCKIST_CONSIGNMENT_BALANCE_CALCULATION_STATUS, result)
        resolve(true)
      })
      .catch(error => {
        reject(error)
      })
  })
}
